import { render, staticRenderFns } from "./Analise.vue?vue&type=template&id=468b0fb5&"
import script from "./Analise.vue?vue&type=script&lang=js&"
export * from "./Analise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports